export { default as Providers } from "./Providers";
export { default as useActionPoll } from "./useActionPoll";
export type { CacheHandle } from "./useActionPoll";

export interface MenuItem {
    id: string;
    name: string;
    price: bigint;
}

export const menu = [
    {
        "id": "coffee",
        "name": "Coffee",
        "price": 800n
    },
    {
        "id": "cookie",
        "name": "Cookie",
        "price": 200n
    },
    {
        "id": "lemonade",
        "name": "Lemonade",
        "price": 300n
    }
];
